// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-dialog__content[data-v-6cc02b44]{z-index:99!important}[data-v-6cc02b44]::-webkit-scrollbar{display:none!important}.item-added-card[data-v-6cc02b44]{bottom:7px;position:fixed;z-index:100}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
